import React, { memo } from 'react';
import './loading.scss';
import { classes } from '@umu/umu-util';

const colorList = ['rgb(54,144,246)', 'rgb(221,69,42)', 'rgb(249,205,39)', 'rgb(36,154,119)', 'rgb(107,58,168)'];
interface IProps {
    // 控制动画暂停
    pauseAnimation?: boolean;
    className?: string;
    style?: React.CSSProperties;
}
const LoadingV2 = memo((props: IProps) => {
    const { className, pauseAnimation = false, style } = props;
    return (
        <div className={classes('page-loading-v2', className)} style={style}>
            {colorList.map((item, index) => {
                return (
                    <div
                        key={index}
                        className={'ball ball_' + index}
                        style={{
                            backgroundColor: item,
                            animationPlayState: pauseAnimation ? 'paused' : 'running',
                        }}
                    ></div>
                );
            })}
        </div>
    );
});
export default LoadingV2;
